import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/category", label: "电影分类" },
  { to: "/news", label: "影视资讯" },
  { to: "/about", label: "关于" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const submitSearch = () => {
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 items-center gap-4 px-4 md:px-6">
        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>

        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-clapperboard-line text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">欧美三级</span>
            <span className="text-[11px] tracking-wider text-secondary-600">影视资源与资讯</span>
          </span>
        </Link>

        <nav className="ml-6 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                [
                  "cursor-pointer rounded-md px-3.5 py-2 text-sm font-medium transition-colors",
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950",
                ].join(" ")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden items-center md:flex">
          <div className="flex h-10 items-center gap-2 rounded-full border border-background-300/80 bg-background-100 pl-3.5 pr-1.5 transition-colors focus-within:border-primary-400">
            <i className="ri-search-line text-base text-secondary-500"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") submitSearch();
              }}
              type="text"
              placeholder="搜索影片或资讯"
              className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-secondary-500 focus:outline-none lg:w-56"
            />
            <button
              type="button"
              onClick={submitSearch}
              className="cursor-pointer whitespace-nowrap rounded-full bg-primary-600 px-3.5 py-1.5 text-xs font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              搜索
            </button>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70 px-4 py-2 md:hidden">
        <div className="flex h-10 items-center gap-2 rounded-full border border-background-300/80 bg-background-100 pl-3.5 pr-1.5">
          <i className="ri-search-line text-base text-secondary-500"></i>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") submitSearch();
            }}
            type="text"
            placeholder="搜索影片或资讯"
            className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-secondary-500 focus:outline-none"
          />
          <button
            type="button"
            onClick={submitSearch}
            className="cursor-pointer whitespace-nowrap rounded-full bg-primary-600 px-3.5 py-1.5 text-xs font-medium text-background-50"
          >
            搜索
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className="animate-fade-in border-t border-background-200/70 bg-background-50 px-4 pb-3 pt-2 md:hidden">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                [
                  "block cursor-pointer rounded-md px-3 py-2.5 text-sm font-medium transition-colors",
                  isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700 hover:bg-background-100",
                ].join(" ")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}